import React from 'react';
import PropTypes from 'prop-types';
import { inputPropTypes } from 'Packages/FacetDesign/Components/propTypes';
import { CheckboxInputLarge, SelectInputLarge } from 'Packages/FacetDesign/Components';

export const MaybeBoolSelect = (props) => {
  const {
    options, value, onChange, ...rest
  } = props;
  const otherOptions = options.filter((option) => option.id !== 'date');

  // If you have exactly 1 option that is not date, then you can draw the switch input to choose a start/end type
  if (otherOptions.length === 1) {
    return (
      <CheckboxInputLarge
        value={value === 'date'}
        onChange={(evt) => {
          onChange(evt.target.checked ? 'date' : otherOptions[0].id);
        }}
        {...rest}
      />
    );
  }

  return (
    <SelectInputLarge {...props} />
  );
};

MaybeBoolSelect.defaultProps = {
  value: undefined,
};

MaybeBoolSelect.propTypes = {
  value: PropTypes.oneOf([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  onChange: inputPropTypes.onChange.isRequired,
};
